import {setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils'
import {UIPopupRulebook} from '../../../../shared/scripts/ui_popup/UIPopupRulebook'
import {RulebookPage} from '../../../../../shared/enums/RulebookEnums'
import {UIHeaderProfileController} from './UIHeaderProfileController'
import {UICoinsController} from '../../../../shared/scripts/ui_coins/UICoinsController'
import {UIHeaderController} from '../../../../shared/scripts/ui_html/header/UIHeaderController'
import {removeURLParams} from '../../../../shared/scripts/ui_utils/Utils'
import {ViewPopupLogin} from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin'
import {stripOAuthTokenFromUrl} from '../../../../shared/scripts/ui_utils/TestableClientUtils'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {AudioManager, AudioType} from '@colonist/audio'
import {UILanguageButtonController} from '../../../../shared/scripts/ui_popup/ui_language/UILanguageButtonController'

type MenuState = 'closed' | 'open'

export class UIWHeaderController extends UIHeaderController {
    private readonly header: HTMLDivElement

    readonly headerProfileController: UIHeaderProfileController

    private readonly hamburger: HTMLDivElement
    private readonly overlayScreen: HTMLDivElement
    private readonly menu: HTMLDivElement
    private readonly closeButton: HTMLDivElement
    private readonly rulebookButton: HTMLLinkElement
    private menuState: MenuState = 'closed'

    private readonly hamburgerLeft: HTMLDivElement
    private readonly sidebarAndMenuOverlay: HTMLDivElement
    private readonly sidebarAndMenu: HTMLDivElement
    private sidebarAndMenuState: MenuState = 'closed'

    private readonly logoButton: HTMLDivElement
    private logoClickCallback?: () => void

    constructor() {
        super()

        this.header = document.getElementById('web-header') as HTMLDivElement

        this.menu = document.getElementById('m-mainpage-menu') as HTMLDivElement
        this.hamburger = document.getElementById('header-element-hamburger-container') as HTMLDivElement
        this.closeButton = document.getElementById('m-mainpage-menu-close') as HTMLDivElement

        this.overlayScreen = document.getElementById('m-mainpage-overlay') as HTMLDivElement

        this.rulebookButton = document.getElementById('m-mainpage-menu-link-rulebook') as HTMLLinkElement

        this.hamburgerLeft = document.getElementById('header-element-hamburger-left') as HTMLDivElement
        this.sidebarAndMenuOverlay = document.getElementById('web-sidebar-and-menu-overlay') as HTMLDivElement
        this.sidebarAndMenu = document.getElementById('web-sidebar-and-menu') as HTMLDivElement

        this.logoButton = document.getElementById('web-header-logo') as HTMLDivElement

        this.headerProfileController = new UIHeaderProfileController()

        this.initLogoClick()
        this.initRightMenu()
        this.initLeftMenu()

        new UICoinsController()

        new UILanguageButtonController(this.menu)
        const leftMenu = document.getElementById('m-mainpage-menu-left') as HTMLDivElement
        new UILanguageButtonController(leftMenu)

        stripOAuthTokenFromUrl()
        UIWHeaderController.displayLoginPopupBasedOnUrlSearchParams()
    }

    hide() {
        this.header.classList.add('hidden')
    }

    show() {
        this.header.classList.remove('hidden')
    }

    private initLogoClick() {
        setElementOnClick(this.logoButton, () => {
            if(this.logoClickCallback) {
                this.logoClickCallback()
            }
        })
    }

    setLogoClickCallback(callback: () => void) {
        this.logoClickCallback = callback
    }

    private initRightMenu() {
        setElementOnClick(this.hamburger, () => this.openMenu())
        setElementOnClick(this.closeButton, () => this.closeMenu())
        setElementOnClick(this.overlayScreen, () => this.closeMenu())
        setElementOnClick(this.rulebookButton, () => {
            AudioManager.play(AudioType.Click)
            new UIPopupRulebook(RulebookPage.Classic4P).show()
        })
    }

    private openMenu() {
        if(this.menuState == 'open') return
        this.menu.classList.add('open')
        this.overlayScreen.classList.remove('hidden')
        this.menuState = 'open'
    }

    closeMenu() {
        if(this.menuState == 'closed') return
        this.menu.classList.remove('open')
        this.overlayScreen.classList.add('hidden')
        this.menuState = 'closed'
    }

    private initLeftMenu() {
        setElementOnClick(this.hamburgerLeft, () => this.openSidebarAndMenu())
        setElementOnClick(this.sidebarAndMenuOverlay, () => this.closeSidebarAndMenu())

        const sidebarAndMenuCloseButton = document.getElementById('m-mainpage-menu-close-left') as HTMLDivElement
        setElementOnClick(sidebarAndMenuCloseButton, () => this.closeSidebarAndMenu())

        const sidebarAndMenuRulebookButton = document.getElementById('m-mainpage-menu-link-rulebook-left') as HTMLLinkElement
        setElementOnClick(sidebarAndMenuRulebookButton, () => {
            AudioManager.play(AudioType.Click)
            new UIPopupRulebook(RulebookPage.Classic4P).show()
        })
    }

    private openSidebarAndMenu() {
        if(this.sidebarAndMenuState == 'open') return
        this.sidebarAndMenu.classList.add('open')
        this.sidebarAndMenuOverlay.classList.remove('hidden')
        this.sidebarAndMenuState = 'open'
    }

    closeSidebarAndMenu() {
        if(this.sidebarAndMenuState == 'closed') return
        this.sidebarAndMenu.classList.remove('open')
        this.sidebarAndMenuOverlay.classList.add('hidden')
        this.sidebarAndMenuState = 'closed'
    }

    protected setupShuffleLinkInterceptor() {
        const notificationPanelContent = this.notificationPanelController.notificationPanelContent

        const shuffleLinks = notificationPanelContent.querySelectorAll('a[href*="#matchmakingqueue=16"]') as NodeListOf<HTMLLinkElement>

        shuffleLinks.forEach((link) => {
            if(link.hasAttribute('data-shuffle-handler')) return
            link.setAttribute('data-shuffle-handler', 'true')

            // eslint-disable-next-line no-restricted-syntax
            link.addEventListener('click', async(event) => {
                event.preventDefault()
                await UIWHeaderController.sendPlayNowClickAnalytic()
                if(!UIUtilsEjsVariables.isUserOnDiscord) window.location.href = link.href
            })
        })
    }

    private static displayLoginPopupBasedOnUrlSearchParams() {
        const urlSearchParams = new URLSearchParams(window.location.search)
        if(!urlSearchParams.has('login-popup')) return

        new ViewPopupLogin()
        removeURLParams()
    }
}
